export const errors = {
    empty: "Field can not be blank",
    email: "Invalid email format",
    containLetters: "Field can not contain letters, only numbers",
    onlyNumbers: "Field can not contains only numbers",
    phone: 'This field is invalid',
    minLength: {
        text: 'Text length can not be less 4 symbols',
        length: 4
    }
}
